import { Box, Grid, Stack, Typography } from '@mui/material';
import {
  AssignmentTurnedIn,
  Cancel,
  Inventory2,
  PauseCircle,
  PlayCircle,
  WarningAmber,
} from '@mui/icons-material';
import Card from 'components/Card';
import styles from './styles';

const OrdensPorStatus = ({ data }) => {
  const statusCards = [
    {
      title: 'Abertas',
      value: data?.abertas || 0,
      icon: Inventory2,
      color: '#1976d2',
      bg: '#e3f2fd',
    },
    {
      title: 'Em Andamento',
      value: data?.em_andamento || 0,
      icon: PlayCircle,
      color: '#2e7d32',
      bg: '#e8f5e9',
    },
    {
      title: 'Paradas',
      value: data?.paradas || 0,
      icon: PauseCircle,
      color: '#ed6c02',
      bg: '#fff3e0',
    },
    {
      title: 'Atrasadas',
      value: data?.atrasadas || 0,
      icon: WarningAmber,
      color: '#d32f2f',
      bg: '#ffebee',
    },
    {
      title: 'Concluídas',
      value: data?.concluidas || 0,
      icon: AssignmentTurnedIn,
      color: '#6a1b9a',
      bg: '#f3e5f5',
    },
    {
      title: 'Canceladas',
      value: data?.canceladas || 0,
      icon: Cancel,
      color: '#616161',
      bg: '#eeeeee',
    },
  ];

  return (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5" fontWeight="bold">
            Ordens de Produção
          </Typography>
        </Grid>
        {statusCards.map((item) => {
          const Icon = item?.icon;
          return (
            <Grid item xs={12} sm={6} md={4} lg={2} key={item?.title}>
              <Card style={styles?.card}>
                <Stack
                  spacing={2}
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      {item?.title}
                    </Typography>
                    <Typography variant="h4" fontWeight="bold">
                      {item?.value}
                    </Typography>
                  </Box>
                  <Box sx={styles?.iconContainer(item)}>
                    <Icon sx={styles?.icon(item)} />
                  </Box>
                </Stack>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default OrdensPorStatus;
